import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowIdPage.MatrixPopupContent.ExactAsyncCondition', {
    selectFieldName: 'Select {fieldName}',
});
